// Tiny haptic helper — no-op on unsupported devices
export function buzz(pattern = 12) {
  try {
    if (typeof navigator !== "undefined" && navigator.vibrate) navigator.vibrate(pattern);
  } catch {
    /* ignore */
  }
}
